import React, { FC, useCallback } from 'react';

import DeleteButton from 'src/presentation/components/pages/shared/DeleteButton';
import { StyledEntityRow, StyledRowItem } from '../shared/StyledComponents';

type ActionRowProps = {
  className?: string;
  type: string;
  onDelete?: Function;
};

const ActionRow: FC<ActionRowProps> = ({ className, children, type, onDelete }) => {
  const onClickDelete = useCallback(() => {
    onDelete && onDelete(type);
  }, [type, onDelete]);

  return (
    <StyledEntityRow className={className}>
      <StyledRowItem>Then</StyledRowItem>
      {children}
      {onDelete ? <DeleteButton id={type} onClick={onClickDelete} /> : null}
    </StyledEntityRow>
  );
};

export default ActionRow;
